import type { Field } from '../../common/types/form';
import type { Documentation } from '../../common/types/documentation';

const dateHoursFields: Field<Documentation>[] = [
  {
    key: 'date',
    label: 'Datum',
    fieldTypes: 'date',
    validateIsNotEmpty: true,
  },
  {
    key: 'hours',
    label: 'Stunden',
    fieldTypes: 'number',
    steps: 0.5,
  },
];

export default dateHoursFields;
